export default function TablaAccesorios({ accesorios, onEdit, onDelete, onVender }) {
  if (accesorios.length === 0) {
    return <div className="inv-empty-state">No se encontraron accesorios registrados para la venta.</div>
  }

  return (
    <div className="inv-table-responsive animate-fade-in">
      <table className="inv-table">
        <thead>
          <tr>
            <th>Categoría</th>
            <th>Nombre / Descripción</th>
            <th>Modelos Compatibles</th>
            <th>Precio Venta</th>
            <th>Stock Disponible</th>
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {accesorios.map(item => {
            const estaAgotado = (item.stock || 0) <= 0;

            return (
              <tr key={item.id}>
                <td style={{ fontWeight: '500', color: 'var(--primary)' }}>{item.categoria}</td>
                <td className="inv-td-model">{item.nombre}</td>
                <td><span className="compatibility-tag">{item.compatibilidad || 'Universal'}</span></td>
                <td className="inv-td-price">
                  {item.precio > 0 ? `US$ ${Number(item.precio).toLocaleString()}` : `ARS$ ${Number(item.precio_ars).toLocaleString('es-AR')}`}
                </td>
                <td>
                  <span className={`stock-indicator ${estaAgotado ? 'low' : item.stock <= 3 ? 'low' : 'ok'}`}>
                    {item.stock} {item.stock === 1 ? 'unidad' : 'unidades'}
                  </span>
                </td>
                <td>
                  <div className="inv-actions-cell">
                    {/* Botón Venta (Solo visible si hay stock disponible) */}
                    {!estaAgotado && (
                      <button 
                        onClick={() => onVender(item)} 
                        className="btn-table-edit" 
                        style={{ backgroundColor: '#10b981', color: 'white', borderColor: '#10b981', marginRight: '5px' }}
                        title="Registrar Venta"
                      >
                        Vender
                      </button>
                    )}

                    <button onClick={() => onEdit(item)} className="btn-table-edit">Editar</button>
                    <button onClick={() => onDelete(item.id)} className="btn-table-delete">Borrar</button>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}